export enum CONDITION_OPERATOR {
  AND = 'AND',
  OR = 'OR',
}
